import React from 'react';
import PublicLayout from '@/components/PublicLayout';
import SEO from '@/components/SEO';

const PrivacyPolicyPage = () => (
  <PublicLayout>
    <SEO title="Privacy Policy" description="EdAssist privacy policy. Learn how we collect, use, and protect your personal information on our education job portal." path="/privacy-policy" />
    <div className="max-w-4xl mx-auto px-4 py-16" data-testid="privacy-policy-page">
      <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit' }}>Privacy Policy</h1>
      <p className="text-slate-500 mb-10">Effective Date: 1st June 2025 | Last Updated: 30th May 2025</p>

      <div className="prose prose-slate max-w-none">
        <h2>Introduction</h2>
        <p>Welcome to EdAssist ("Company", "we", "our", "us"). We respect your privacy and are committed to protecting the personal information you provide while using our job board platform. This Privacy Policy explains how we collect, use, disclose, and safeguard your information.</p>

        <h2>1. Information We Collect</h2>
        <h3>a. From Job Seekers:</h3>
        <ul>
          <li>Name, email address, phone number</li>
          <li>Educational qualifications and work experience</li>
          <li>Resume/CV, professional certifications</li>
          <li>Job preferences and application history</li>
          <li>Any other information that might be relevant to support their candidature</li>
        </ul>
        <h3>b. From Employers:</h3>
        <ul>
          <li>Organization name and contact details</li>
          <li>Job postings and related descriptions</li>
          <li>Recruiter names, email addresses, and phone numbers</li>
        </ul>
        <h3>c. Automatically Collected:</h3>
        <ul>
          <li>IP address and browser information</li>
          <li>Device information and usage data</li>
          <li>Cookies and similar tracking technologies</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Provide and improve our recruitment services</li>
          <li>Match job seekers with relevant job opportunities</li>
          <li>Allow employers to review applications</li>
          <li>Send job alerts, notifications, and service updates</li>
          <li>Ensure platform security and prevent fraud</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2>3. Sharing of Information</h2>
        <p>We do not sell your personal data. We may share data with:</p>
        <ul>
          <li>Employers who post jobs on EdAssist (for applicants only)</li>
          <li>Third-party service providers assisting with platform operations (e.g., hosting, analytics, payment gateways)</li>
          <li>Legal authorities, if required by law or to protect our legal rights</li>
        </ul>

        <h2>4. Data Retention</h2>
        <p>We retain your personal information as long as your account is active or as needed to provide you services. You may request deletion of your data at any time by contacting us.</p>

        <h2>5. Your Rights</h2>
        <ul>
          <li>Access or correct your personal data</li>
          <li>Delete your profile or data upon request</li>
          <li>Opt out of marketing communications</li>
        </ul>
        <p>To exercise these rights, email us at <a href="mailto:info@edassist.co.in" className="text-indigo-600">info@edassist.co.in</a>.</p>

        <h2>6. Cookies</h2>
        <p>We use cookies to enhance user experience and analyze platform usage. You may disable cookies in your browser settings, though some features may be affected.</p>

        <h2>7. Data Security</h2>
        <p>We implement industry-standard security measures to protect user data from unauthorized access, loss, or misuse. However, no transmission method is 100% secure, and users are encouraged to take precautions such as strong passwords.</p>

        <h2>8. Children's Privacy</h2>
        <p>EdAssist is not intended for individuals under the age of 18. We do not knowingly collect data from children.</p>

        <h2>9. Third-Party Links</h2>
        <p>Our platform may contain links to third-party websites. We are not responsible for their privacy practices and encourage users to read external policies.</p>

        <h2>10. Updates to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with a revised effective date. Continued use of the platform constitutes acceptance of the updated policy.</p>

        <h2>11. Contact Us</h2>
        <p>For any questions or concerns about this Privacy Policy:</p>
        <p><strong>EdAssist</strong><br />(HRassistance India Consultancy LLP)<br />Email: <a href="mailto:info@edassist.co.in" className="text-indigo-600">info@edassist.co.in</a><br />Address: 205A, Town Square, Viman Nagar, Pune-411014, India</p>
      </div>
    </div>
  </PublicLayout>
);

export default PrivacyPolicyPage;
